import { Col, Row, Modal, Form, Switch, Select, message } from "antd";
import { useTranslation } from "react-i18next";
import { Dispatch, useEffect, useState } from "react";
import Title from "../../UI/Title/Title";
import { ItemsType } from "../itemsType";
import { createItems, editItems, getItemsBy } from "../../../api/itemapi";
import { UseMutateAsyncFunction, useMutation, useQuery } from "react-query";
import { InputNumber } from "../../UI/InputNumberComponent/inputnumber";
import InputName from "../../UI/InputNumberComponent/InputName";
import TextArea from "../../UI/InputNumberComponent/TextArea";
import { AxiosResponse } from "axios";
import Modalls from "./modall";

type propsType = {
  itemid?: string;
  Packaging?: ItemsType;
  id?: string | number;
  openPackaging: boolean;
  formatedItemUnit: {}[] | undefined;
  loadingItemUnit: boolean;
  categoryId: any;
  type: any;
  setOpenPackaging: React.Dispatch<React.SetStateAction<boolean>>;
  setPaginatedItemPackaging: Dispatch<any>;
  ItemPackagingMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      itemsId: string | undefined;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
  search: any;
};
export const AddEditPackaging = ({
  openPackaging,
  setOpenPackaging,
  Packaging,
  id,
  itemid,
  formatedItemUnit,
  loadingItemUnit,
  categoryId,
  type,
  setPaginatedItemPackaging,
  ItemPackagingMutation,
  search,
}: propsType) => {
  const [, setError] = useState("");
  const [isActive, setIsActive] = useState<boolean | undefined>(
    Packaging ? Packaging?.isActive : true
  );
  const [isTrackable, setIsTrackable] = useState<boolean | undefined>(
    Packaging ? Packaging?.isTrackable : true
  );
  const [isTaxable, setIsTaxable] = useState<boolean | undefined>(
    Packaging ? Packaging?.isTaxable : false
  );
  const isEdit = () => {
    return id;
  };
  const [t] = useTranslation("common");
  const [isopen, setisOpen] = useState(false);
  const [form] = Form.useForm();
  const [editStatus] = useState(isEdit());
  const [, setItemName] = useState("");
  const [name, setName] = useState(false);
  const [barcode, setBarcode] = useState(false);
  const [unitValue, setUnitValue] = useState(false);
  const [selectedItemUnit, setSelectedItemUnit] = useState<any>(null);
  const handleNameChange = (event: any) => {
    setName(event);
  };

  const handleBarcodeChange = (event: any) => {
    setBarcode(event);
  };

  const handleUnitValueChange = (event: any) => {
    setUnitValue(event);
  };

  useEffect(() => {
    if (editStatus) {
      setName(true);
      setBarcode(true);
      setUnitValue(true);
      setSelectedItemUnit(true);
    }
  }, [editStatus]);

  /*Item name By Id */
  const { data: itemData } = useQuery("item", () => getItemsBy(itemid), {
    onSuccess: (itemName) => {
      setItemName(itemName);
    },
  });

  const onError = (error: any, variables: ItemsType, context: unknown) => {
    let errorMessage = "An error occurred";
    if (error.response && error.response.data && error.response.data.errors) {
      const errorData = error.response.data.errors[0];
      if (errorData && errorData.msg) {
        errorMessage = `${errorData.param} ${errorData.msg}`;
      }
    } else if (
      error.response &&
      error.response.data &&
      error.response.data.message
    ) {
      errorMessage = error.response.data.message;
    } else {
      errorMessage = error.message;
    }
    if (setError) {
      setError(errorMessage);
    }
    message.error({
      content: errorMessage,
      duration: 10,
      onClick: () => {
        message.destroy();
      },
    });
  };

  const { mutate: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createItems" : "editItems",
    !isEdit()
      ? (item: ItemsType) => createItems(item)
      : (item: ItemsType) => editItems(id, item),
    {
      onSuccess: (res) => {
        setisOpen(false);
        setOpenPackaging(false);
        message.success("Complete successfully");
        ItemPackagingMutation({
          q: search,
          itemsId: itemid,
        }).then((res: any) => {
          setPaginatedItemPackaging(res.data?.childrenItems);
        });
      },
      onError,
    }
  );
  const handleFinish = async () => {
    const newItemPackaging = form.getFieldsValue();

    for (const key in newItemPackaging) {
      if (newItemPackaging[key] === undefined) {
        if (
          key === "isActive" ||
          key === "isTrackable" ||
          key === "isTaxable"
        ) {
          newItemPackaging[key] = true;
        } else {
          newItemPackaging[key] = null;
        }
      } else if (
        typeof newItemPackaging[key] === "string" &&
        newItemPackaging[key].trim() === ""
      ) {
        newItemPackaging[key] = null;
      }
    }
    newItemPackaging.isPacking = false;
    newItemPackaging["categoryId"] = categoryId;
    newItemPackaging["typeId"] = type;
    newItemPackaging["isComposed"] = true;
    newItemPackaging["parentId"] = itemid;
    mutateCreateUpdate(newItemPackaging);
  };
  return (
    <>
      <Modal
        data-testid="modal"
        closable={false}
        maskClosable={false}
        centered
        width={1000}
        onCancel={() => setOpenPackaging(false)}
        open={openPackaging}
        cancelText={t("cancel")}
        okButtonProps={{
          style: {
            height: "40px",
            background: "#1677FF",
            color: "#fff",
            width: "100px",
          },
          disabled: !name || !unitValue || !selectedItemUnit,
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        okText={isEdit() ? `${t("save")}` : `${t("add")}`}
        onOk={() => {
          setisOpen(true);
        }}
      >
        <Col offset={1}>
          {" "}
          <Title
            title={
              isEdit() ? `${t("edit-packaging")}` : `${t("add-packaging")}`
            }
          />
        </Col>
        {isEdit() ? (
          <Col offset={1} span={20} className="modaltitleEdit">
            {Packaging?.name}
          </Col>
        ) : (
          <Col
            offset={1}
            span={20}
            style={{ marginBottom: "14px" }}
            className="modaltitleEdit"
          >
            {t("add-packaging-to-the")} {""} {itemData}
          </Col>
        )}

        <Form
          data-testid="form"
          className="no-hover-label"
          layout="vertical"
          form={form}
          onFinish={handleFinish}
          id="packagingForm"
          initialValues={{
            name: Packaging?.name,
            description: Packaging?.description,
            unitId: Packaging?.unit?.id,
            unitValue: Packaging?.unitValue,
            sku: Packaging?.sku,
            barcode: Packaging?.barcode,
            width: Packaging?.width,
            height: Packaging?.height,
            depth: Packaging?.depth,
            isTrackable: isEdit() ? Packaging?.isTrackable : true,
            isActive: isEdit() ? Packaging?.isActive : true,
            isTaxable: isEdit() ? Packaging?.isTaxable : false,
            weight: Packaging?.weight,
          }}
        >
          <Row style={{ marginTop: "20px" }}>
            <Col span={6} offset={1}>
              <Form.Item
                name="name"
                label={`${t("name")}`}
                rules={[
                  {
                    required: true,
                    message: "name is required",
                  },
                ]}
              >
                <InputName
                  maxLength={50}
                  autoComplete="off"
                  placeholder={`${t("enter-text")}`}
                  onChange={handleNameChange}
                />
              </Form.Item>

              <Form.Item
                name="barcode"
                label={`${t("barcode")}`}
                // rules={[
                //   {
                //     required: true,
                //     message: "barcode is required",
                //   },
                // ]}
              >
                <InputName
                  maxLength={20}
                  autoComplete="off"
                  placeholder="Enter something"
                  onChange={handleBarcodeChange}
                />
              </Form.Item>

              <Form.Item
                name="unitId"
                label={`${t("item-unit")}`}
                rules={[
                  {
                    required: true,
                    message: "item unit is required",
                  },
                ]}
              >
                <Select
                  data-testid="unitItem"
                  placeholder={`${t("select-item-unit")}`}
                  loading={loadingItemUnit}
                  options={formatedItemUnit}
                  showSearch={true}
                  optionFilterProp="label"
                  onChange={(value: any) => setSelectedItemUnit(value)}
                />
              </Form.Item>

              <Form.Item
                name="unitValue"
                label={`${t("unit-value")}`}
                rules={[
                  {
                    required: true,
                    message: "unit value is required",
                  },
                ]}
              >
                <InputNumber onChange={handleUnitValueChange} maxLength={11} />
              </Form.Item>
            </Col>

            <Col offset={1} span={6}>
              <Form.Item name="height" label={`${t("height")}`}>
                <InputNumber maxLength={11} />
              </Form.Item>

              <Form.Item name="width" label={`${t("width")}`}>
                <InputNumber maxLength={11} />
              </Form.Item>

              <Form.Item name="depth" label={`${t("depth")}`}>
                <InputNumber maxLength={11} />
              </Form.Item>

              <Form.Item name="weight" label={`${t("Weight")}`}>
                <InputNumber maxLength={11} />
              </Form.Item>
            </Col>

            <Col offset={1} span={6}>
              <Form.Item name="sku" label={t("sku")}>
                <InputName
                  maxLength={20}
                  autoComplete="off"
                  placeholder={`${t("enter-text")}`}
                />
              </Form.Item>

              <Form.Item name="description" label={`${t("description")}`}>
                <TextArea maxLength={500} />
              </Form.Item>
            </Col>
            <Col offset={1}>
              <Form.Item name="isActive" label={`${t("status")}`}>
                <Switch
                  data-testid="switch-toggle"
                  checkedChildren={`${t("active")}`}
                  unCheckedChildren={`${t("inactive")}`}
                  checked={isActive}
                  disabled={isEdit() ? false : true}
                  onChange={(num: boolean) => {
                    setIsActive(num);
                  }}
                />
              </Form.Item>

              <Form.Item name="isTaxable" label={`${t("taxable")}`}>
                <Switch
                  data-testid="switch-toggle"
                  checkedChildren={`${t("yes")}`}
                  unCheckedChildren={`${t("no")}`}
                  checked={isTaxable}
                  onChange={(num: boolean) => {
                    setIsTaxable(num);
                  }}
                />
              </Form.Item>

              <Form.Item name="isTrackable" label={`${t("trackable")}`}>
                <Switch
                  data-testid="switch-toggle"
                  checkedChildren={`${t("yes")}`}
                  unCheckedChildren={`${t("no")}`}
                  checked={isTrackable}
                  onChange={(num: boolean) => {
                    setIsTrackable(num);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Modalls
        form="packagingForm"
        isopen={isopen}
        setisOpen={setisOpen}
        name={<span>{Packaging?.name}</span>}
        title={itemData}
        itemid={id}
        isSaving={isSaving}
      />
    </>
  );
};
